import { Stack } from 'office-ui-fabric-react/lib/Stack'
import { Text } from 'office-ui-fabric-react/lib/Text'
import { stackStyles } from './renderers'

import React from 'react'

export let status_thank_you_renderer = (input: string) => {
  return <p className="form__thanks" dangerouslySetInnerHTML={{ __html: input }} />
}

export let status_sending_renderer = () => {
  return (
    <Stack styles={stackStyles}>
      <Stack>
        <Text variant={'mediumPlus'} className="message">
          Versturen...
        </Text>
      </Stack>
    </Stack>
  )
}

export let status_error_renderer = () => {
  return (
    <Stack styles={stackStyles}>
      <Stack>
        <Text variant={'mediumPlus'} className="message message--error">
          Er is iets misgegaan, probeer het later nog eens...
        </Text>
      </Stack>
    </Stack>
  )
}
